import { useContext, useState } from "react";

import { OrderListingContext } from "../context/OrderListingContext";
import { OrderListingFilters } from "./useOrderListingFilters";

export const useOrderListing = () => {
    const {
        items,
        totalItems,
        selectedItems,
        pinnedItems,
        setSelectedItems,
        reloadData,
        mergeListItems,
        addItemToMergeList,
        removeItemsFromMergeList
    } = useContext(OrderListingContext);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const getData = async (filters: OrderListingFilters): Promise<void> => {
        setIsLoading(true);

        await reloadData(filters);

        setIsLoading(false);
    };

    return {
        items,
        totalItems,
        isLoading,
        pinnedItems,
        getData,
        addItemToMergeList,
        removeItemsFromMergeList,
        mergeListItems,
        setSelectedItems,
        selectedItems
    };
};
